import { Outlet } from 'react-router-dom'

import Ninethgrade_k9_subjects from './ninethgrade_k9_subjects.jsx';
import TopNavbar from '../../components/TopNavbar.jsx';


const Ninethgrade_k9 = ( ) => {
 
  return (
    <>
   
   
  <TopNavbar />
  <Ninethgrade_k9_subjects />  
  
     <Outlet />
    
     </>

  )
}

export default Ninethgrade_k9;